import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_PROGRAM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => ({ ...oldDoc, enabledExamTypes: [] }),
  3: (oldDoc) => ({ ...oldDoc, enabledDeviceIds: [] }),
  4: (oldDoc) => ({ ...oldDoc, turnaroundTargetMinutes: null }),
  5: (oldDoc) => oldDoc,
  6: (oldDoc) => oldDoc,
  7: (oldDoc) => oldDoc,
  8: (oldDoc) => ({
    ...oldDoc,
    clinicalSetting: "ed",
    billingModifierOverride: null,
  }),
  9: (oldDoc) => oldDoc,
};
